/**
 * KEY==Value for equality checks
 */
export enum BeaconTypeEnum {
  B_IMPLEMENT = 'BImpl',
  B_DRIVER = 'BDrv',
}
